export const LANGUAGE_TO_LOCALE = {
  Chinese: 'zh',
  English: 'en',
  Japanese: 'ja',
  Korean: 'ko',
  Spanish: 'es',
  German: 'de',
  French: 'fr',
  Malay: 'ms-MY',
  Indonesian: 'id-ID',
  CantoneseHK: 'yue-Hant-HK',
  CantoneseGD: 'yue-Hans-CN',
}

export const LOCALE_TO_LANGUAGE = Object.entries(LANGUAGE_TO_LOCALE).reduce(
  (acc, [language, locale]) => {
    acc[locale] = language
    return acc
  },
  {}
)

export const LANGUAGE_LABELS = {
  English: 'English',
  Chinese: '中文',
  Japanese: '日本語',
  Spanish: 'Español',
  Korean: '한국어',
  German: 'Deutsch',
  French: 'Français',
  Malay: 'Bahasa Melayu',
  Indonesian: 'Bahasa Indonesia',
  CantoneseHK: '香港粤语',
  CantoneseGD: '广东粤语',
}

export const getLocaleFromLanguage = (language) =>
  LANGUAGE_TO_LOCALE[language] || 'en'

export const getLanguageFromLocale = (locale) =>
  LOCALE_TO_LANGUAGE[locale] || 'English'

// 将浏览器的 BCP 47 语言标签映射到后端 interview_execute.language 使用的内部值。
export const getPreferredLanguageFromBrowser = () => {
  const browserLanguages =
    typeof navigator === 'undefined'
      ? []
      : navigator.languages?.length
      ? navigator.languages
      : [navigator.language || navigator.userLanguage]

  for (const browserLanguage of browserLanguages) {
    const normalizedLanguage = String(browserLanguage || '')
      .trim()
      .toLowerCase()
      .replace(/_/g, '-')

    if (normalizedLanguage.startsWith('yue-hant')) return 'CantoneseHK'
    if (normalizedLanguage.startsWith('yue-hans')) return 'CantoneseGD'
    if (normalizedLanguage === 'yue') return 'CantoneseHK'
    if (normalizedLanguage.startsWith('zh')) return 'Chinese'
    if (normalizedLanguage.startsWith('ja')) return 'Japanese'
    if (normalizedLanguage.startsWith('ko')) return 'Korean'
    if (normalizedLanguage.startsWith('es')) return 'Spanish'
    if (normalizedLanguage.startsWith('de')) return 'German'
    if (normalizedLanguage.startsWith('fr')) return 'French'
    if (normalizedLanguage.startsWith('ms')) return 'Malay'
    if (normalizedLanguage.startsWith('id')) return 'Indonesian'
    if (normalizedLanguage.startsWith('en')) return 'English'
  }

  return 'English'
}

export const getLanguageOptions = (languages = []) =>
  languages
    .filter((language) => LANGUAGE_LABELS[language])
    .map((language) => ({
      value: language,
      label: LANGUAGE_LABELS[language],
    }))
